import React from "react";
import WorkerWeeklyReport from "../modules/WorkerWeeklyReport/WorkerWeeklyReport";
export default function WorkerWeeklyReportPage() {
  return <WorkerWeeklyReport />;
}
